import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@campfire-nx/material';

// Open components
import { OpenSvgIconComponent } from './components/open-svg-icon/open-svg-icon.component';
import { OpenSvgLogoComponent } from './components/open-svg-logo/open-svg-logo.component';
import { OpenTileRadioComponent } from './components/open-tile-radio/open-tile-radio.component';
import { OpenTileCheckboxComponent } from './components/open-tile-checkbox/open-tile-checkbox.component';
import { OpenTileToggleComponent } from './components/open-tile-toggle/open-tile-toggle.component';
import { OpenTileBlockComponent } from './components/open-tile-block/open-tile-block.component';
import { OpenTileDetailComponent } from './components/open-tile-detail/open-tile-detail.component';
import { OpenTooltipComponent } from './components/open-tooltip/open-tooltip.component';
import { OpenCounterComponent } from './components/open-counter/open-counter.component';
import { OpenRangeSliderComponent } from './components/open-range-slider/open-range-slider.component';
import { OpenPriceComponent } from './components/open-price/open-price.component';
import { OpenFlowBannerComponent } from './components/open-flow-banner/open-flow-banner.component';
import { OpenCardComponent } from './components/open-card/open-card.component';
import { OpenBadgeComponent } from './components/open-badge/open-badge.component';
import { OpenSocialRatingComponent } from './components/open-social-rating/open-social-rating.component';
import { OpenButtonToggleComponent } from './components/open-button-toggle/open-button-toggle.component';

// Open pipes
import { OpenStringInjectionPipe } from './pipes/open-string-injection.pipe';
import { OpenSanitizedHtmlPipe } from './pipes/open-sanitized-html.pipe'; 

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  declarations: [
    OpenSvgIconComponent,
    OpenSvgLogoComponent,
    OpenTileRadioComponent,
    OpenTileCheckboxComponent,
    OpenTileToggleComponent,
    OpenTileBlockComponent,
    OpenTileDetailComponent,
    OpenTooltipComponent,
    OpenCounterComponent,
    OpenRangeSliderComponent,
    OpenPriceComponent,
    OpenFlowBannerComponent,
    OpenCardComponent,
    OpenBadgeComponent,
    OpenStringInjectionPipe,
    OpenSocialRatingComponent,
    OpenButtonToggleComponent,
    OpenSanitizedHtmlPipe
  ],
  exports: [
    OpenSvgIconComponent,
    OpenSvgLogoComponent,
    OpenTileRadioComponent,
    OpenTileCheckboxComponent,
    OpenTileToggleComponent,
    OpenTileBlockComponent,
    OpenTileDetailComponent,
    OpenTooltipComponent,
    OpenCounterComponent,
    OpenRangeSliderComponent,
    OpenPriceComponent,
    OpenFlowBannerComponent,
    OpenCardComponent,
    OpenBadgeComponent,
    OpenSocialRatingComponent,
    OpenButtonToggleComponent,
    OpenStringInjectionPipe,
    OpenSanitizedHtmlPipe
  ],
  providers: [ 
    OpenStringInjectionPipe,
    OpenSanitizedHtmlPipe
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ] // allow the lottie player element
})
export class OpenModule {}
